import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";

const root = ReactDOM.createRoot(
  document.getElementById("us-elections-widget__app") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (
  window.location.host === "localhost:3000" &&
  process.env.REACT_APP_STYLE_URL
) {
  const styleLink = document.createElement("link");
  styleLink.rel = "stylesheet";
  styleLink.href = process.env.REACT_APP_STYLE_URL;
  document.head.appendChild(styleLink);
}
